import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { useTheme } from '../../contexts/ThemeContext';

const formatAxisCurrency = (value) => {
  if (value >= 1000) return `$${(value / 1000).toFixed(1)}k`;
  return `$${value}`;
};

const formatTooltipCurrency = (value) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);

export default function CashFlowChart({ moneyIn, moneyOut, monthLabel }) {
  const { isDark } = useTheme();
  const gridStroke = isDark ? '#475569' : '#e2e8f0';
  const tickFill = isDark ? '#94a3b8' : '#64748b';
  const yTickFill = isDark ? '#cbd5e1' : '#475569';

  const data = [
    { name: 'In', amount: moneyIn, fill: '#0d9488' },
    { name: 'Out', amount: moneyOut, fill: '#0066cc' },
  ];

  return (
    <div className="h-[200px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 8, right: 8, left: 8, bottom: 8 }}
          layout="vertical"
        >
          <CartesianGrid strokeDasharray="3 3" stroke={gridStroke} horizontal={false} />
          <XAxis type="number" tickFormatter={formatAxisCurrency} tick={{ fontSize: 11, fill: tickFill }} />
          <YAxis type="category" dataKey="name" width={36} tick={{ fontSize: 12, fill: yTickFill }} axisLine={false} tickLine={false} />
          <Tooltip
            content={({ active, payload }) => {
              if (!active || !payload?.length) return null;
              return (
                <div className="rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 px-3 py-2 shadow-lg">
                  <p className="text-xs text-slate-500 dark:text-slate-400 mb-0.5">{payload[0].payload.name === 'In' ? 'Money in' : 'Money out'}</p>
                  <p className="text-sm font-semibold text-slate-900 dark:text-white">{formatTooltipCurrency(payload[0].value)}</p>
                  <p className="text-xs text-slate-400 dark:text-slate-500">{monthLabel}</p>
                </div>
              );
            }}
            cursor={{ fill: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.04)' }}
          />
          <Bar dataKey="amount" radius={[0, 4, 4, 0]} maxBarSize={48}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
